import CandidateMatchScoresScreen from 'pages/iPriseV2/common/candidate-match-scores';
import ViewCandidate from 'pages/iPriseV2/common/view-candidate';
import ViewJobV2 from 'pages/iPriseV2/common/view-job';
import ViewMatchedCandidate from 'pages/iPriseV2/common/view-matched-candidate';
import Candidates from 'pages/iPriseV2/recruiter/candidates';
import JobQueue from 'pages/iPriseV2/recruiter/job-queue';
import Header from 'pages/iPriseV2/recruiter/layout/Header';
import RecruiterProfile from 'pages/iPriseV2/recruiter/profile';
import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

const RecruiterRoutes = () => {
  return (
    <Routes>
      <Route path="recruiter" element={<Header />}>
        <Route index element={<Navigate to="job-queue" replace />} />
        <Route path="job-queue" element={<JobQueue />} />
        <Route path="view-job/:id" element={<ViewJobV2 />} />
        <Route
          path="view-matched-candidate"
          element={<ViewMatchedCandidate />}
        />
        <Route
          path="view-matched-candidate-scores"
          element={<CandidateMatchScoresScreen />}
        />
        <Route path="view-candidate/:candidateId" element={<ViewCandidate />} />
        <Route path="candidates" element={<Candidates />} />
        <Route path="profile" element={<RecruiterProfile />} />
      </Route>
      {/* Redirect any unknown route to recruiter/job-queue */}
      <Route path="*" element={<Navigate to="recruiter/job-queue" replace />} />
    </Routes>
  );
};

export default RecruiterRoutes;
